import { Injectable } from '@angular/core';
import { DataManagerService } from '../../services/data-manager.service';
import { DeletionService } from '../../services/deletion.service';
import { LoggingService } from '../../services/logging.service';
import { FeatureFlagService } from '../../services/feature-flags.service';
import { ReasonForChangeService } from '../../common/reason-for-change/reason-for-change.service';
import { ToastrService } from '../../services/toastr.service';
import { EnumerationStateService } from './enumeration-state.service';
import { GlpOdataFacetSaveServiceBulk } from '@services/glp-odata-facet-save-bulk.service';

@Injectable()
export class EnumerationSaveService extends GlpOdataFacetSaveServiceBulk {
    protected saveSource = 'enumeration';

    constructor(
        protected dataManagerService: DataManagerService,
        protected deletionService: DeletionService,
        protected loggingService: LoggingService,
        protected featureFlagService: FeatureFlagService,
        protected reasonForChangeService: ReasonForChangeService,
        protected toastrService: ToastrService,
        private enumerationStateService: EnumerationStateService,
    ) {
        super(
            dataManagerService,
            deletionService,
            loggingService,
            featureFlagService,
            reasonForChangeService,
            toastrService,
            enumerationStateService,
        );
    }
}
